<template>
	<div class="animated fadeIn">
		<DatasetHeaderV2 :record_id="record_id" :type="type">
			<data-set :type="type"></data-set>
		</DatasetHeaderV2>
	</div>
</template>

<script>
	import {DatasetHeaderV2} from '../../components'
	import dataSet from '../../components/dataset'

	export default {
		name: 'datasetList',
		components: {
			DatasetHeaderV2,
			dataSet,
		},
		data() {
			return {
				record_id: 0,
				type: 'dataset',
			}
		},
		mounted() {
			if (parseInt(this.$route.params.id) >= 1) {
				this.record_id = parseInt(this.$route.params.id)
			}
		},
	}
</script>
